/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PersonMatches/Content/UseSelectedAction/Content",
  isSubmitting
  
}) {
let personMatchesIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'person_matches',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 data="person_matches"
 disabled={personMatchesIsSubmittingData}
 onClick={onClick}
 text="Use selected person"
/>
{children}
</React.Fragment>)
}